module.exports = __webpack_public_path__ + "assets/booking-logo-gs.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/booking-logo-gs.png
// module id = 1207
// module chunks = 7